import { contentManagementConstants } from '../constants';
import defaultImage from "assets/img/image_placeholder.jpg";

var initialState = {
    formOpen: false,
    formMode: 'add',
    formInitialValue: {},
    tableKey: 0,
    tableDatas: {
        data: [],
        total: 0
    },
    tableReset: false,
    tableReload: false,
    tableLoader: false,
    contentImagePreview: defaultImage,
    contentImageEnPreview: defaultImage,
    contentDesktopImagePreview: defaultImage,
    contentDesktopImageEnPreview: defaultImage,
    mobileImageSelected: false,
    mobileImageEnSelected: false,
    desktopImageSelected: false,
    desktopImageEnSelected: false,
    mobileImageUpdated: false, 
    mobileImageEnUpdated: false, 
    desktopImageUpdated: false,
    desktopImageEnUpdated: false,
    contentManagementData: [],
    showLoader: false,
    tableFilter: {
        page: 0,
        skip: 0,
        limit: 10,
        sortBy: "updated_at",
        sortDir: "desc",
        keyword: "",
        search: {}
    },
}

export function content_management(state = initialState, action) {
    switch (action.type) {
        case contentManagementConstants.OPEN_FORM_ADD:
            return {
                ...state,
                formOpen: true,
                formMode: 'add',
                formInitialValue: {
                    status: "Active",
                    contentType: 'news'
                },
                contentImagePreview: defaultImage,
                contentImageEnPreview: defaultImage,
                contentDesktopImagePreview: defaultImage,
                contentDesktopImageEnPreview: defaultImage,
                mobileImageSelected: false,
                mobileImageEnSelected: false,
                desktopImageSelected: false,
                contentImageEnPreview: defaultImage,
            };
        case contentManagementConstants.OPEN_FORM_EDIT:
            return {
                ...state,
                formOpen: true,
                formMode: 'edit',
                formInitialValue: action.data,
                contentImagePreview: action.mobileImageFilePath,
                contentImageEnPreview: action.mobileImageEnFilePath,
                contentDesktopImagePreview: action.desktopImageFilePath,
                contentDesktopImageEnPreview: action.desktopImageEnFilePath,
                mobileImageSelected: action.mobileImageSelected,
                mobileImageEnSelected: action.mobileImageEnSelected,
                desktopImageSelected: action.desktopImageSelected,
                desktopImageEnSelected: action.desktopImageEnSelected,
                mobileImageUpdated: false, 
                mobileImageEnUpdated: false, 
                desktopImageUpdated: false,
                desktopImageEnUpdated: false,
            };
        case contentManagementConstants.EDIT_CONTENT_MANAGEMENT_SUCCESS:
            return {
                ...state,
                formOpen: false,
                formInitialValue: {},
                tableReset: false,
                tableReload: true
            }
        case contentManagementConstants.CLOSE_FORM_CONTENT_MANAGEMENT:
            return {
                ...state,
                formOpen: false,
                formInitialValue: {
                    contentImagePreview: "",
                 },
                 contentImagePreview: defaultImage,
                 contentDesktopImagePreview: defaultImage,
            }
        case contentManagementConstants.ADD_CONTENT_SUCCESS:
            return {
                ...state,
                formOpen: false,
                formInitialValue: {},
                contentImagePreview: defaultImage,
                contentDesktopImagePreview: defaultImage,
                tableReload: false,
                tableReset: true,
                tableKey: new Date(),
            }
        case contentManagementConstants.SET_FORM_PREVIEW_IMAGE_CONTENT_MANAGEMENT:
            return {
                ...state,
                contentImagePreview: action.contentImagePreview === "default"? defaultImage : action.contentImagePreview,
                mobileImageSelected: action.contentImagePreview === "default"? false : true,
                mobileImageUpdated: action.mobileImageUpdated,
            }
        case contentManagementConstants.SET_FORM_PREVIEW_IMAGE_CONTENT_MANAGEMENT_EN:
            return {
                ...state,
                contentImageEnPreview: action.contentImageEnPreview === "default"? defaultImage : action.contentImageEnPreview,
                mobileImageEnSelected: action.contentImageEnPreview === "default"? false : true,
                mobileImageEnUpdated: action.mobileImageEnUpdated,
            }
        case contentManagementConstants.SET_FORM_PREVIEW_IMAGE_CONTENT_MANAGEMENT_DESKTOP:
            return {
                ...state,
                contentDesktopImagePreview: action.contentDesktopImagePreview === "default"? defaultImage : action.contentDesktopImagePreview,
                desktopImageSelected: action.contentDesktopImagePreview === "default"? false : true,
                desktopImageUpdated: action.desktopImageUpdated,
            }
        case contentManagementConstants.SET_FORM_PREVIEW_IMAGE_CONTENT_MANAGEMENT_DESKTOP_EN:
            return {
                ...state,
                contentDesktopImageEnPreview: action.contentDesktopImageEnPreview === "default"? defaultImage : action.contentDesktopImageEnPreview,
                desktopImageEnSelected: action.contentDesktopImageEnPreview === "default"? false : true,
                desktopImageEnUpdated: action.desktopImageEnUpdated,
            }
        case contentManagementConstants.GET_CONTENT_MANAGEMENT_DATA_SUCCESS:
            return {
                ...state,
                contentManagementData: action.data
            }
        case contentManagementConstants.TABLE_GET_LIST_CONTENT_MANAGEMENT:
            return {
                ...state,
                tableDatas: action.data,
                total: action.data.total,
                tableReload: false,
                tableReset: false
            }
        case contentManagementConstants.TABLE_RELOAD_SUCCESS:
            return {
                ...state,
                tableReload: false,
                tableReset: false,
            }
        case contentManagementConstants.DELETE_CONTENT_SUCCESS:
            return {
                ...state,
                tableReload: true
            }
        default:
            return state;
    }
}